<template>
    <div class="text-xs text-blue-700 bg-blue-50 rounded-full px-2 py-1">
        <slot>Lesson</slot>
    </div>
</template>
